import { flushWebOutbox } from './outboxSyncWeb';
import { syncCatalogIfChangedWeb } from './catalogSyncWeb';

let installed = false;

export function installWebSyncHooks() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const run = async () => {
    try { await syncCatalogIfChangedWeb(); } catch {}
    try { await flushWebOutbox(); } catch {}
  };

  window.addEventListener('online', run);
  window.addEventListener('focus', run);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void run();
  });

  void run();
}
